/**
 * Format a stage ID to a display-friendly name
 * Examples: 'regular_season' → 'Regular Season', 'playoffs' → 'Playoffs'
 */
export const formatStageName = (stageId: string): string => {
  if (!stageId) return '';
  
  // Split by underscore and capitalize each word
  return stageId
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Convert a formatted stage name back to stage ID format
 * Examples: 'Regular Season' → 'regular_season', 'Playoffs' → 'playoffs'
 */
export const parseStageId = (stageName: string): string => {
  if (!stageName) return '';
  
  // Convert to lowercase and replace spaces with underscores
  return stageName
    .toLowerCase()
    .replace(/\s+/g, '_');
};
